import { render, staticRenderFns } from "./PlanPBK.vue?vue&type=template&id=41a54784&"
import script from "./PlanPBK.vue?vue&type=script&lang=js&"
export * from "./PlanPBK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports